
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-integrations",
      function () {
        return require("private-next-pages/partner-integrations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-integrations"])
      });
    }
  